import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_report_section_gl_category_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  report_section_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gl_category_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_report_section_gl_category_link_RowClass
  implements bl_fi_report_section_gl_category_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    report_section_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gl_category_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
}
